import React, {useEffect, useState} from "react";
import GoogleMapReact from "google-map-react";
import MapDevice from "./map_device/map_device";
import useMQTTService from "../../../components/mqtt_service/mqtt_service";
import styles from './map_view.module.css';
import {getBooleanLabel} from "../../../components/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {HighAlert, LowAlert, MediumAlert} from "../../../components/alerts/alerts";
import axiosInstance from "../../../AxiosInstance";

export default function MapView({data}) {
    const [selectedDevice, setSelectedDevice] = useState(null);
    const mapOptions = {
        center: {
            lat: 14.72,
            lng: -17.45
        },
        zoom: 10
    };

    //const { loaded, data, reconnecting, reconnected } = useMQTTService();

    const [receivedData, setReceivedData] = useState(data);

    const parsedVariable = (value) => {
        if (value.type === 1) {
            return (
                <div>{parseInt(value.value)}</div>
            )
        }
        else if (value.type === 2) {
            return (
                <div>{parseFloat(value.value).toFixed(value.precision)}</div>
            )
        }
        else if (value.type === 5 || value.variable?.type === 5) {
            return (
                <div>{getBooleanLabel(value).label}</div>
            )
        }
        else {
            return (
                <div>{value.value}</div>
            )
        }
    }

    const getAlert = (variable) => {
        if(variable.value > variable.high_threshold) {
            return <HighAlert disabled={false}/>
        } else if(variable.value > variable.medium_threshold) {
            return <MediumAlert disabled={false}/>
        } else {
            return <LowAlert disabled={false}/>
        }
    }

    return (
        <div className={'my-3'} style={{height: "800px", width: "100%"}}>
            <GoogleMapReact
                onClick={() => setSelectedDevice(null)}
                defaultCenter={mapOptions.center}
                defaultZoom={mapOptions.zoom}
                bootstrapURLKeys={{ key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g'}}
                yesIWantToUseGoogleMapApiInternals
            >
                {receivedData?.map((device, index) => (
                    <MapDevice
                        setSelectedDevice={setSelectedDevice}
                        device={device}
                        key={index}
                        lat={device.latitude}
                        lng={device.longitude}
                    />
                ))}
            </GoogleMapReact>

            {/* Device details window */}
            {selectedDevice && (
                <div className={`${styles.mapViewWindow}`}>
                    <div className={`${styles.deviceBox}`}>
                        <div>
                            <span>{selectedDevice.name}</span>
                            <span className={'ps-2'}>{selectedDevice.variables.length} active sensors</span>
                        </div>
                        {selectedDevice.variables.map((variable, index) => (
                            <div key={index}>
                                <div className={`${styles.variableBox}`}>
                                    <div style={{flexBasis: "33%"}}>{variable?.variable?.name}</div>
                                    <div style={{flexBasis: "33%"}}>{parsedVariable(variable)}</div>
                                    {getAlert(variable)}
                                    {/*<FontAwesomeIcon icon={variable?.isOpen ? faChevronUp : faChevronDown} color={'#94A3B8'} role={'button'} onClick={() => {
                                        setSelectedDevice({
                                            ...selectedDevice,
                                            items: selectedDevice.items?.map((v, i) => {
                                                if (i === index) {
                                                    return {
                                                        ...v,
                                                        isOpen: !v.isOpen
                                                    }
                                                }
                                                return v;
                                            })
                                        })
                                    }}/>*/}
                                </div>
                                {variable.isOpen && (
                                    <div className={`${styles.descriptionBox}`}>
                                        <div className={'d-flex flex-column'}>
                                            <span>Min: {variable.min} {variable.unit}</span>
                                            <span>Max: {variable.max} {variable.unit}</span>
                                        </div>
                                        <div style={{color: '#4F46E5', fontWeight: '600', userSelect: 'none'}} className={'d-flex'} role={'button'}>Show Graphic</div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}